import React from "react";
import PropTypes from "prop-types";
import { CloseButton, Image } from "@learningblocks/shared-components";
import "./style.scss";
import { FullscreenModal } from "@learningblocks/storybook-components";

import { connect } from "react-redux";

function PopUpThumbnail(props) {
  const magnifications = props.magnifications;
  const image = magnifications.find((magnification) => {
    return magnification.value === props.selectedThumbnail.value;
  });

  return (
    <FullscreenModal isOpen={props.isOpen} close={props.onClose}>
      <div className="thumbnailWrapper">
        <div className="thumbnailWrapper__closeButton">
          <CloseButton close={props.onClose} />
        </div>
        <div className="thumbnailWrapper__imageWrapper">
          <div className="thumbnailWrapper__imageWrapper--magnification">
            <p>{image && image.value}</p>
          </div>
          <div className="thumbnailWrapper__imageWrapper--image">
            <Image
              width="100%"
              src={
                image
                  ? `images/sorter/leaf_${image.value}.svg`
                  : "images/sorter/Plate.svg"
              }
              alt="Microscope Image"
              style={{ height: "465px" }}
            />
          </div>
        </div>
      </div>
    </FullscreenModal>
  );
}

PopUpThumbnail.propTypes = {
  /**
   * Url of the image to be displayed on the clickable thumbail
   */
  src: PropTypes.string,
  /**
   * The current magnification the microscope is currently set to
   */
  magnification: PropTypes.string,

  /**
   * Modal state whether it is open or close
   */
  isOpen: PropTypes.bool,

  /**
   * Function to be called when the modal is close
   */
  onClose: PropTypes.func,

  /**
   * Determines whether the notebook is collapsed or not
   */
  notebookCollapsed: PropTypes.bool,
};

function mapStateToProps(state) {
  const sorterState = state.sorter;

  return {
    magnifications: sorterState.magnifications,
    selectedThumbnail: sorterState.selectedThumbnail,
  };
}

function mapDispatchToProps() {
  return {};
}

export const Thumbnail = connect(
  mapStateToProps,
  mapDispatchToProps
)(PopUpThumbnail);
